import { useCallback, useState } from 'react'
import Project from 'common/project'

interface LegalSubField {
  id: string
  master_term: string
  image: string | null
  text_definition: string | null
  audio_master_term: string | null
  audio_text_definition: string | null
}

interface LegalSubFieldsResponse {
  count: number
  next: string | null
  previous: string | null
  results: LegalSubField[]
}

export const useLegalFieldsTemplate = () => {
  const [legalSubFields, setLegalSubFields] = useState<LegalSubField[]>([])

  const loadLegalSubFields = useCallback(async (area: string) => {
    try {
      const response = await fetch(
        `${
          Project.liveApi
        }law-categorisation/subareas-with-media-by-areas/?area=${encodeURIComponent(
          area,
        )}`,
      )
      const data: LegalSubFieldsResponse = await response.json()
      setLegalSubFields(data.results || [])
    } catch (error) {
      console.error('Failed to load legal subfields:', error)
    }
  }, [])

  return {
    loadLegalSubFields,
    legalSubFields,
  }
}
